module.exports = __webpack_public_path__ + "img/FR12906.8f1655bb.png";